import { Drawer, Typography } from '@mui/material';
import {
  EXTERNAL_INTEGRATIONS,
  EXTERNAL_INTEGRATIONS_ITEMS,
  Integration,
} from 'js/constants/externalIntegrations';
import { Configuration } from 'new/components/settings/Integrations/Configuration';
import React, { cloneElement, useState } from 'react';
import styles from './IntegrationList.module.scss';
import { Item, ItemProps } from './Item';

type CatalogProps = {
  integrationType: string;
  title?: string;
  description?: string;
  itemAdapter: (integration: Integration) => ReturnType<typeof WrappedItem>;
};

const WrappedItem = (
  props: Pick<ItemProps, 'onActivationChange' | 'isActive' | 'disableActivation'>,
) => {
  return <Item {...props} />;
};

function IntegrationList(props: CatalogProps) {
  const { integrationType, title, description, itemAdapter } = props;

  const integrations = EXTERNAL_INTEGRATIONS_ITEMS[integrationType].map(
    (name) => EXTERNAL_INTEGRATIONS[name],
  );
  const [selected, setSelected] = useState<Integration>(null);

  const onCloseDrawer = () => {
    setSelected(null);
  };

  const onOpenDrawer = (integration: Integration) => () => {
    setSelected(integration);
  };

  const itemMapper = (integration: Integration) => {
    const ItemComponent = itemAdapter(integration);
    return cloneElement(ItemComponent, {
      key: integration.meta.name,
      integration,
      onOpenConfiguration: onOpenDrawer(integration),
    });
  };

  return (
    <>
      <div className={styles.sectionHeader}>
        <Typography variant="body2">
          <strong>{title}</strong>
          <br />
          {description}
        </Typography>
      </div>

      <div className={styles.container}>{integrations.map(itemMapper)}</div>

      <Drawer anchor="right" open={!!selected} onClose={onCloseDrawer}>
        <Configuration
          integrationType={integrationType}
          integration={selected}
          onClose={onCloseDrawer}
        />
      </Drawer>
    </>
  );
}

IntegrationList.Item = WrappedItem;

export default IntegrationList;
